export { environments } from '@8fig/environments';

export const stage = {
  inventoryDeposit: {
    value: 'inventoryDeposit',
    label: 'Inventory Deposit',
    shortName: 'Deposit',
    description:
      'Depending on your agreement with the manufacturer, you may be asked to pay for production in 2 or more installments. The Deposit funds delivery would be the first installment due.',
  },
  remainingBalance: {
    value: 'remainingBalance',
    label: 'Remaining Balance',
    shortName: 'Balance',
    description:
      'Depending on your agreement with the manufacturer, you may be asked to pay for production in 2 or more installments. The Balance funds delivery, or funds deliveries, would be the installment due after the Deposit.',
  },
  freight: {
    value: 'freight',
    label: 'Freight',
    description:
      'Costs incurred to ship the inventory from the manufacturer to its destination.',
  },
  '3pl': {
    value: '3pl',
    label: 'Logistics',
    header: '3PL',
    description:
      'Logistics costs may include local warehouse storage, quality assurance, de-vanning, palletizing, merchant-fulfillment costs, and similar. Please do not include FBA fees.',
  },
  marketing: {
    value: 'marketing',
    label: 'Marketing',
    description:
      'Marketing costs to support sales, including pay-per-click advertising.',
  },
  sellingStart: {
    value: 'sellingStart',
    label: 'Stock on Hand',
    description:
      'The date you anticipate this batch will be on hand, ready to sell.',
  },
  other: {
    value: 'other',
    label: 'Other',
    description:
      "Use this stage to track any costs you have that don't fit into the other stages.",
  },
  repaymentsStart: {
    value: 'repaymentsStart',
    label: 'Remittances Start',
    shortName: 'Repay',
    image: '/status/pending.svg',
  },
  complete: {
    value: 'complete',
    label: 'Complete',
    image: '/status/active.svg',
  },
};

export const specialStages = [
  stage.sellingStart.value,
  stage.repaymentsStart.value,
  stage.complete.value,
];

export const lineStatus = {
  draft: 'draft',
  submitted: 'submitted',
  pending: 'pending',
  active: 'active',
  complete: 'complete',
  inactive: 'inactive',
};

export const applicationStatus = {
  submitted: { typeId: 0, status: 'submitted' },
  active: { typeId: 1, status: 'active' },
  pending: { typeId: 2, status: 'pending' },
  complete: { typeId: 3, status: 'complete' },
  review: { typeId: 4, status: 'review' },
  rejected: { typeId: 5, status: 'rejected' },
  archived: { typeId: -1, status: 'archived' },
};

export enum adminRejectedChangeRequest {
  // 1-10 common reasons for payments and lines
  Other = 1,
  IncompleteData = 2,
  UnjustifiedOrUnclear = 3,
  WrongVehicle = 4,

  // 10-100 lines reasons
  UnsupportedGrowthAttempting = 10,
  FastExposureChanges = 11,
  LowMargin = 12,

  // 100-200 payments reasons
  MayLeadToDefaultUsersCashFlow = 100,
}

export enum adminRejectedApplication {
  InsufficientSales = 1,
  SellerQuality,
  IncompleteData,
  FastExposure,
  UnsupportedGrowth,
  NegativeGrowth,
  LowMargin,
  Other,
}

export enum Scroll {
  'body' = 'body',
  'paper' = 'paper',
}

export enum ApplicationType {
  NEW_PLAN = 'New Plan',
  CLONE_NO_CHANGES = 'Clone (No changes)',
  CHANGE_REQUEST_NEW_LINES = 'Change Request New Lines',
  CHANGE_REQUEST = 'Change Request',
  TERMINATION_PLAN_REQUEST = 'Plan Termination',
}
